const getters = {
  token: state => state.user.token,
  user: state => state.user.user,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js